import PropTypes from 'prop-types'

import { useDirectDebitStatus } from '../../../../../contexts/session/DirectDebitContext'
import BottomSheet from '../../../../elements/direct-debit/BottomSheet'
import Button from '../../../../elements/direct-debit/Button'
import DDIcon from '../../../../icons/DDIcon'
import styles from './HowItWorksSheet.module.css'

const STEPS = [
  { icon: 'step-verify', title: 'Verify it’s you', sub: 'A quick code by email or SMS.' },
  { icon: 'step-bank', title: 'Add your bank account', sub: 'The account the merchant will debit.' },
  { icon: 'step-send', title: 'Send a one-time ₦50', sub: 'This switches the mandate on.' },
]

// Spec screen 01b - entry-point explainer sheet. "Get started" closes the sheet and
// advances straight to 02 (Your details), matching the entry CTA's own behaviour.
// FLAG: spec's limit note ("Up to ₦X per payment, until <date>") isn't wired up - the
// first iteration never read a per-payment limit or mandate end date from the backend.
// See final report.
const HowItWorksSheet = ({ isOpen, onClose }) => {
  const { showYourDetails } = useDirectDebitStatus()

  const handleGetStarted = () => {
    onClose()
    showYourDetails()
  }

  return (
    <BottomSheet
      isOpen={isOpen}
      onClose={onClose}
      icon='sheet-question'
      title='How it works'
      description='Three quick steps to set up Direct Debit for this merchant.'
    >
      <div className={styles.stepsContainer}>
        {STEPS.map((step) => (
          <div key={step.icon} className={styles.stepRow}>
            <span className={styles.stepIcon}>
              <DDIcon name={step.icon} />
            </span>
            <div>
              <div className={styles.stepTitle}>{step.title}</div>
              <div className={styles.stepSub}>{step.sub}</div>
            </div>
          </div>
        ))}
      </div>
      <Button onClick={handleGetStarted}>Get started</Button>
    </BottomSheet>
  )
}

HowItWorksSheet.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default HowItWorksSheet
